import { realToCents } from '@/commons/formatters/currency';
import { paymentLinkResource } from '../resources/paymentLink';
import moment from '@transfeeradev/moment';

export async function createPaymentLink(paymentData) {
  const payment = {
    payment_methods: ['pix'],
    amount: realToCents(paymentData.amount),
    name: paymentData.name,
    description: paymentData.description,
    expires_at: moment(paymentData.expirationDate).toISOString()
  };
  return paymentLinkResource.create(payment);
}

export async function listPaymentLink() {
  return paymentLinkResource.list();
}

export async function deletePaymentLink() {
  return Promise.resolve({
    id: '3b12f1df-5230-63a3-a150-d4c4afb4e3a6',
    status: 'pendente',
    payinID: '3b12f1df-5230-63a3-a150-d4c4afb4e3a6',
    paymentTypes: ['pix'],
    amount: 10000,
    name: 'Link de pagamento criado',
    description: 'Link de pagamento criado para o pagamento de dívida com o SERASA',
    link: 'https://lpag.transfeera.io/c?tk=+V5LDyIaA5jYzQMWptQ1Gw==',
    createdAt: '2021-09-01T00:00:00Z',
    updatedAt: '2021-09-01T00:00:00Z',
    expiresAt: '2021-09-01T00:00:00Z'
  });
}
